<template>
  <v-app id="inspire" class="gb login landing">
    <div class="header-container">
      <div class="module-container">
        <site-header-landing/>
      </div>
    </div>
    <div
        class="module-container"
    >

      <div class="home">
        <div class="banner">
          <div>
            <h1>
              Our new product
              is launching soon.
            </h1>
            <p style="opacity: 0">We are currently working very hard on getting you a fantastic product.</p>

            <ValidationObserver ref="validator">
              <div class="form-web">
                <ValidationProvider
                    ref="email"
                    rules="required|email"
                    v-slot="{ errors }"
                >
                  <input v-model="email" class="form-email" type="email" required placeholder="Email"/>
                  <div v-if="errors.length > 0" class="error--text">{{ errors[0] }}</div>
                </ValidationProvider>
                <div class="input-group no-pad">
                  <div class="input-group-area">
                    <button @click="submit">Reserve a Spot<br>for FREE.</button>
                  </div>
                </div>
              </div>
            </ValidationObserver>

            <div class="form-success">
              Thank you for your interest in KIEY, we will be in touch!
            </div>

            <div class="input-group-icon"><small>Free Spots: <span id="counterUsers">loading ...</span></small></div>
          </div>
          <img :src="require('@/assets/img/landing/bg.svg')" alt/>
        </div>
        <div class="copy">
          <p>Copyright © KIEY 2026</p>
          <ul>
            <li>
              <a href=""><img :src="require('@/assets/img/landing/facebook.svg')" alt="facebook"/></a>
            </li>
            <li>
              <a href=""><img :src="require('@/assets/img/landing/youtube.svg')" alt="youtube" class="img-copy"/></a>
            </li>
            <li>
              <a href=""><img :src="require('@/assets/img/landing/link.svg')" alt="linkeding"/></a>
            </li>
          </ul>
        </div>
      </div>

    </div>
  </v-app>
</template>

<script lang="ts">
  import SiteHeaderLanding from '@/components/layout/SiteHeaderLanding.vue';
  import {ValidationObserver, ValidationProvider} from 'vee-validate';
  const firebase = require("@/config/firebase");
  const config = require("@/config/constants");

  export default {
    name: 'Landing',
    components: {
      SiteHeaderLanding,
      ValidationObserver,
      ValidationProvider,
    },
    data() {
      return {
        email: "",
        numberUsers: 200
      };
    },
    created() {
      const self = this;
      // Store the unsubscribe so beforeDestroy can detach it — otherwise a new
      // freeSpots listener leaks on every visit to the Landing page.
      this.unsubscribeFreeSpots = firebase.firestore
          .collection("freeSpots")
          .onSnapshot(function (snapshot) {
            snapshot.docChanges().forEach(function () {
              self.numberUsers--;
              document.getElementById("counterUsers").innerHTML = self.numberUsers;
            });
          }, err => {
            console.error(err);
          });
    },
    beforeDestroy() {
      if (this.unsubscribeFreeSpots) {
        this.unsubscribeFreeSpots();
        this.unsubscribeFreeSpots = null;
      }
    },
    methods: {
      async submit() {
        if (await this.$refs.validator.validate() === true) {
          let formWeb = document.getElementsByClassName("form-web")[0];
          let formSuccess = document.getElementsByClassName("form-success")[0];

          let request = new XMLHttpRequest();
          request.open('POST', config.default.api_url + 'reserve_spot', true);
          request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
          request.send("email=" + this.email);

          request.onload = function () {
            if (this.status >= 200 && this.status < 400) {
              formSuccess.style.display = 'block';
              formWeb.style.display = 'none';
            }
          };

          request.onerror = function () {
            // alert("There was a problem, we are working on this");
          };
        }
      }
    }
  };
</script>

<style lang="scss">
  @import '@/assets/css/landing';
</style>
